import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { CommonModule } from '@angular/common';
import { TextAreaInputComponent } from '../text-area-input/text-area-input.component';
import { MaterialModule } from '../../../material/material.module';
import { RouterModule } from '@angular/router';
import { MatHint } from '@angular/material/form-field';

@Component({
  selector: 'app-disabled-input',
  templateUrl: './disabled-input.component.html',
  styleUrls: ['./disabled-input.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    TextAreaInputComponent,
    RouterModule,
    MatHint,
  ],
})
export class DisabledInputComponent extends BaseInputDirective implements OnInit, AfterViewInit {
  @Input() valueOverride;
  @Input() url: string = '';
  @Input() onClick: () => void = null;

  @ViewChild('linkWrapper') private linkWrapper: ElementRef;

  
 



  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngOnInit();

    if (this.linkWrapper) {
      const linkElement = this.linkWrapper.nativeElement;
      const parentElement = (linkElement) ? this.linkWrapper.nativeElement.parentElement : null;
      if (linkElement && parentElement) {
        parentElement.appendChild(this.linkWrapper.nativeElement);
      }
    }
  }
}
